import React, { useState } from 'react';
import Main from './Components/Main/Main';
import MenuBar from './Components/MenuBar/MenuBar';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Settings from './Components/Settings/Settings';
import SettingsContext from './Context/SettingsContext';
import { loadSettings } from './common/help-functions';



function App() {
  const [ settingsState, setSettingsState ] = useState(loadSettings);

  return (
      <SettingsContext.Provider value={{ settingsState, setSettingsState }}>
        <BrowserRouter>
          <MenuBar />
          <Routes>
            <Route exact path='/' element={<Main />}/>
            <Route exact path='/settings' element={<Settings />}/>
            <Route path='*' element={<Navigate to='/' replace />}/>
          </Routes>
        </BrowserRouter>
      </SettingsContext.Provider>
  );
}

export default App;
